export function getStyle({ draggableStyle, virtualStyle, isDragging }: any) {
  if (!virtualStyle || virtualStyle === "") {
    return draggableStyle;
  }

  const combined = {
    ...virtualStyle,
    ...draggableStyle,
  };

  const grid = 8;

  const result = {
    ...combined,
    height: isDragging ? combined.height : combined.height - grid,
    left: isDragging ? combined.left : combined.left + grid,
    width: isDragging
      ? draggableStyle.width
      : `calc(${combined.width} - ${grid * 2}px)`,
    marginBottom: grid,
  };
  return result;
}
